import styled from "styled-components";

export const CustomDataTableContainer = styled.div`
  padding: 10px;
  padding-bottom: 0px;

  .custom-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    .left-toolbar {
      display: flex;
      .pageBtn {
        margin-right: 10px;
      }
      .columns-menu {
        display: flex;
      }
    }
  }
    .contactTdRow.checkboxTd{padding: 1px 13px;}
  .contactTdRow.checkboxTd .checkboxkp{padding: 3px;}
  .create-btn {
    background: #00a4e5;
    border-radius: 50%;
    padding: 6px;
    font-size: 10px;
    color: #fff;
    margin-left: 10px;
    &:hover {
      background-color: #0582c0;
      color: #fff;
      border: 1px solid #269bd5;
    }
  }

  .search-toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .search-bar {
      position: relative;
    }

    .search-input {
      color: #707070;
      font-size: 15px;
      font-weight: 400;
      border: 1px solid #e5e7ef;
      border-radius: 5px;
      background-color: white;
      padding: 6px;
      padding-right: 34px;
    }

    .search-icon {
      position: absolute;
      top: 8px;
      right: 10px;
      color: #707070;
    }
  }

  .custom-table-container {
    overflow-x: auto;
    /* margin-top: 10px; */
    height: 495px !important;
    /* overflow: hidden; */
  }

  .custom-table {
    width: 100%;
    border-collapse: collapse;
  }

  .custom-table thead {
    position: sticky;
    top: 0;
    z-index: 2;
  }
  .filterRow{}
  .filterRow td{border-bottom:1px solid #dddddd !important;padding:0 5px !important;background : #fff !important;}

  .custom-table th {
    padding: 0 8px;
    border-bottom: 1px solid #ddd;
    background-color: #e5e7ef;
  }
  .custom-table tr:nth-child(odd) td {
    background-color: #f4f5f8;
  }

  .custom-table tr:nth-child(even) td {
    background-color: #ffffff;
  }
  .custom-table td {
    padding: 8px;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: left;
  }

  .filter-td {
    border-right: 0;
  }

  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .name_link {
    text-decoration: none;
  }

  .no-record {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .kp {
    border: none;
    border-bottom: 1px solid #8e8e8e;
    &:focus-visible {
      border: none;
      border-bottom: 1px solid #8e8e8e;
      outline: none;
    }
  }

  .MuiMenuItem-root {
    font-family: "Plus Jakarta Sans", sans-serif;
  }

  .filter-design {
    position: sticky;
    top: 34px;
    background: #fff;
    z-index: 1;
  }

  .filter-design-safari {
  top: 94px !important;
  }

  #my-table {
    position: relative;
    background-color: #fff;
  }


  .custom-table-row{
    position: absolute;
    top:38px;
    left:0;
    // dispaly: -webkit-flex !important;
    display: flex !important;
  }
    .custom-table-row-safari {
    display: table !important;
    top : 33px !important;
    height: 365px;
    width: 100%;
    }

    .mainlistContainer {
    height: 359px !important;
    overflow: hidden !important;
    }
`;
